var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.file)?_c('a',{staticClass:"file",attrs:{"href":_vm.file.url,"download":""}},[_c('FileIcon'),_c('div',{staticClass:"info"},[_c('span',[_vm._v(_vm._s(_vm.file.name))]),_c('span',{staticClass:"file-size"},[_vm._v(_vm._s(_vm.fileAttachment.fileSizeFormatted))])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }